import type { AvailableLocales } from '@eliadmin/core/src/stores/locale-store';
export type { AvailableLocales };
import { getHolidays as skHolidays, isPublicHoliday as skHoliday } from '@eliadmin/core/src/build/calendars/slovak-delivery';
const tables: Record<string, Record<number, string[]>> = {};
export function getHolidays(locale: AvailableLocales, year = new Date().getFullYear()): Date[] {
const key = locale.trim().toLowerCase();
if (key === 'sk') return skHolidays(locale, year);
if (!tables[key]) throw new Error('Delivery calendar locale not included in build: ' + key);
if (!tables[key][year]) throw new Error('Delivery calendar year outside build coverage: ' + year);
return tables[key][year].map(value => new Date(value));
}
export function isPublicHoliday(date: Date, locale: AvailableLocales): boolean {
if (locale.trim().toLowerCase() === 'sk') return skHoliday(date, locale);
return getHolidays(locale, date.getFullYear()).some(h => h.getMonth() === date.getMonth() && h.getDate() === date.getDate());
}
